import BreadCrumbs from "../../common/breadcrumbs";
import SearchBox from "../../common/searchBox";
import Table from "../../common/table";
import ReactTooltip from "react-tooltip";
import Icon from "../../icons/index";
import { useStore } from "../../../zustand/store";
import qs from "qs";
import CS from "../../../services/commonService";
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
	usegetAllTransactionsOrders,
	useDownloadTransactionOrders,
} from "../../../queryHooks/usePayouts";
import { useGetAllRestaurants } from "../../../queryHooks";
import { useGetAllPaymentStatus } from "../../../queryHooks/useGifts";
import { saveAs } from "file-saver";
import { URL } from "../../../constants/URL";
import { modules } from "../../../constants/Modules";
import { getCurrentTimezoneDate } from "../../../util/columnsOrdering";

const columnKey = "upcomingPayouts";
//	Component starts
const Transactions = () => {
	//	State values

	const navigate = useNavigate();

	const [tableData, setTableData] = useState([]);
	const lastPageData = useStore((state) => state.lastPageData);
	const setLastPageData = useStore((state) => state.setLastPageData);
	const [itemsPerPage, setItemsPerPage] = useState(
		lastPageData?.[modules.TRANSACTIONS]?.items_per_page || 10
	);
	const [pageNow, setPageNow] = useState(
		lastPageData?.[modules.TRANSACTIONS]?.page || 1
	);
	const [restaurants, setRestaurants] = useState([]);

	const paymentOptions = [
		{ value: "CREATED", label: "CREATED" },
		{ value: "FAILED", label: "FAILED" },
		{ value: "PENDING", label: "PENDING" },
		{ value: "REFUNDED", label: "REFUNDED" },
		{ value: "SUCCESSFUL", label: "SUCCESSFUL" },
	];

	// const [paymentStatus, setPaymentStatus] = useState();

	// const { data: dataGetPaymentstatus } = useGetAllPaymentStatus();

	// useEffect(() => {
	// 	if (dataGetPaymentstatus && dataGetPaymentstatus.data) {
	// 		let _payment = [];
	// 		dataGetPaymentstatus.data.forEach((element) => {
	// 			_payment.push({
	// 				label: element.value,
	// 				value: element.value,
	// 			});
	// 		});
	// 		setPaymentStatus(_payment);
	// 	}
	// }, [dataGetPaymentstatus]);

	const [transactionsPayload, setTransactionsPayload] = useState(
		lastPageData?.[modules.TRANSACTIONS] || {
			pagination: true,
			items_per_page: itemsPerPage,
			page: pageNow,
			sort: { created_at: "DESC" },
		}
	);

	const { data: dataGetTransactionsOrders, isLoading } =
		usegetAllTransactionsOrders(qs.stringify(transactionsPayload));

	useEffect(() => {
		if (
			dataGetTransactionsOrders &&
			dataGetTransactionsOrders.status === "success"
		) {
			let respData = dataGetTransactionsOrders.data;
			respData.page = pageNow;
			respData.items_per_page = itemsPerPage;
			setTableData(respData);
		}
	}, [dataGetTransactionsOrders]);

	const {
		mutateAsync: downloadTransactionsOrders,
		data: dataDownloadTransactionsOrders,
		isLoading: isLoadingDownload,
	} = useDownloadTransactionOrders(transactionsPayload);

	useEffect(() => {
		if (dataDownloadTransactionsOrders) {
			saveAs(dataDownloadTransactionsOrders.data?.filePath, "users.xlsx");
		}
	}, [dataDownloadTransactionsOrders]);

	const { data: dataGetAllRestaurants } = useGetAllRestaurants(
		qs.stringify({
			pagination: false,
			filter: { ["admin_approval_status"]: "APPROVED" },
		})
	);

	useEffect(() => {
		if (dataGetAllRestaurants && dataGetAllRestaurants.data?.records) {
			let _restaurants = [];
			dataGetAllRestaurants.data.records.forEach((element) => {
				_restaurants.push({
					label: element.name,
					value: element.id,
				});
			});
			setRestaurants(_restaurants);
		}
	}, [dataGetAllRestaurants]);

	const columns = [
		{
			label: "Gift Id",
			type: "string",
			maxWidth: true,
			path: "order_id",
			content: (item) => (
				<>
					<Link
						to={{
							pathname: `${URL.giftOrders}/${item?.order_id}`,
							state: { key: "upcomingPayouts" },
						}}
						onClick={() => {
							setLastPageData({ [modules.TRANSACTIONS]: transactionsPayload });
						}}
					>
						{/* <span>{CS.renderImageUrl(item.restaurantPhoto)}</span> */}
						<span className="pl-2">{item?.order_id}</span>
					</Link>
				</>
			),
		},
		{
			label: "Date",
			type: "date",
			path: "created_at",
			alias: "created_at",
			sort: true,
			filterDate: true,
			content: (item) => (
				<span>
					{item?.created_at ? getCurrentTimezoneDate(item.created_at) : null}
				</span>
			),
		},
		{
			label: "User",
			type: "string",
			path: "orders.user_id",
			aliasFilter: "orders.user_id",
			alias: "user.first_name",
			filterUsers: true,
			content: (item) => (
				<Link
					to={{
						pathname: `${URL.onboarderedUsers}/${item.user?.user_id}`,
						state: { key: "giftOrders" },
					}}
					onClick={() => {
						setLastPageData({ [modules.TRANSACTIONS]: transactionsPayload });
					}}
				>
					<div className="d-flex align-items-center pr-3">
						{/* <div className="flex-auto">
							{CS.renderImageUrl(item.gifter?.profile_image_url)}
						</div> */}
						<div className="d-flex flex-column flex-wrap">
							<span className="pl-2">
								{item.user?.first_name} {item.user?.last_name}
							</span>
						</div>
					</div>
				</Link>
			),
		},
		{
			label: "Restaurant",
			type: "string",
			path: "orders.restaurant_id",
			aliasFilter: "orders.restaurant_id",
			alias: "restaurant.name",
			filterOptions: restaurants,
			content: (item) => (
				<Link
					to={{
						pathname: `${URL.restaurants}/${item.restaurant?.restaurant_id}`,
						state: { key: "giftOrders" },
					}}
					onClick={() => {
						setLastPageData({ [modules.TRANSACTIONS]: transactionsPayload });
					}}
				>
					<div className="d-flex align-items-center pr-3">
						{/* <div className="flex-auto">
							{CS.renderImageUrl(item.gifter?.profile_image_url)}
						</div> */}
						<div className="d-flex flex-column flex-wrap">
							<span className="pl-2">{item.restaurant?.name}</span>
						</div>
					</div>
				</Link>
			),
		},
		{
			label: "Gross Amount",
			type: "string",
			sort: true,
			path: "gross_amount",
			alias: "gross_amount",
			content: (item) => (
				<div className="d-flex justify-content-center">
					{item.gross_amount ? "$" + item.gross_amount : "--"}
				</div>
			),
		},

		{
			label: "Discount",
			type: "string",
			sort: true,
			path: "discount",
			alias: "discount",
			content: (item) => (
				<div className="d-flex justify-content-center">
					{item.discount ? "$" + item.discount : "--"}
				</div>
			),
		},
		{
			label: "Reward Discount",
			type: "string",
			sort: true,
			path: "reward_discount",
			alias: "reward_discount",
			content: (item) => (
				<div className="d-flex flex-column align-items-center">
					{Number(item.reward_discount) > 0 ? (
						<>
							<span>-${item.reward_discount}</span>
							<span className="badge badge-success" title="OPA Rewards points used. OPA funds this discount; the restaurant is paid in full.">
								Reward used
							</span>
						</>
					) : (
						"--"
					)}
				</div>
			),
		},
		{
			label: "Estimated Tax",
			type: "string",
			sort: true,
			path: "tax",
			alias: "tax",
			content: (item) => (
				<div className="d-flex justify-content-center">
					{item.tax ? "$" + item.tax : "--"}
				</div>
			),
		},

		{
			label: "Tip",
			type: "number",
			path: "tip",
			content: (item) => (
				<div className="d-flex justify-content-center">
					{item.tip ? "$" + item.tip : "--"}
				</div>
			),
		},
		{
			label: "Service Charge",
			type: "number",
			path: "service_charge",
			content: (item) => (
				<div className="d-flex justify-content-center">
					{item.service_charge ? "$" + item.service_charge : "--"}
				</div>
			),
		},
		{
			label: "Delivery Fee",
			type: "number",
			path: "delivery_fee",
			content: (item) => (
				<div className="d-flex justify-content-center">
					{item.delivery_fee ? "$" + item.delivery_fee : "--"}
				</div>
			),
		},
		{
			label: "Service Fee",
			type: "number",
			path: "service_fee",
			content: (item) => (
				<div className="d-flex justify-content-center">
					{item.service_fee ? "$" + item.service_fee : "--"}
				</div>
			),
		},
		{
			label: "Net Amount",
			type: "string",
			path: "net_amount",
			alias: "net_amount",
			sort: true,
			content: (item) => (
				<div className="d-flex justify-content-center">
					{item.net_amount ? "$" + item.net_amount : "--"}
				</div>
			),
		},
		{
			label: "Platform Fee",
			type: "string",
			sort: true,
			path: "platform_fee",
			alias: "platform_fee",
			content: (item) => (
				<div className="d-flex justify-content-center">
					{item.platform_fee ? "$" + item.platform_fee : "--"}
				</div>
			),
		},

		{
			label: "Merchant Fee",
			type: "string",
			sort: true,
			path: "merchant_fee",
			alias: "merchant_fee",
			content: (item) => (
				<div className=" d-flex justify-content-center">
					{item.merchant_fee ? "$" + item.merchant_fee : "--"}
				</div>
			),
		},
		{
			label: "Net Payable Restaurant",
			type: "string",
			sort: true,
			path: "net_restaurant_amount",
			alias: "net_restaurant_amount",
			content: (item) => (
				<div className="d-flex justify-content-center">
					{item.net_restaurant_amount ? "$" + item.net_restaurant_amount : "--"}
				</div>
			),
		},
		{
			label: "Net Payable OPA",
			type: "string",
			sort: true,
			path: "net_platform_amount",
			alias: "net_platform_amount",
			content: (item) => (
				<div className="d-flex justify-content-center">
					{item.net_platform_amount ? "$" + item.net_platform_amount : "--"}
				</div>
			),
		},
		{
			label: "Payment Status",
			type: "string",
			path: "payment_status",
			aliasFilter: "payment_status.value",
			filterOptions: paymentOptions,
			content: (item) => (
				<div className="d-flex justify-content-center">
					{item.payment_status ? item.payment_status : "--"}
				</div>
			),
		},

		// {
		// 	label: "Tax Rate",
		// 	type: "string",
		// 	sort: true,
		// 	path: "tax_rate",
		// 	content: (item) => (
		// 		<div className="d-flex align-items-center">
		// 			{item.tax_rate ? "$" + item.tax_rate : ""}
		// 		</div>
		// 	),
		// },

		{
			label: "Action",
			type: "boolean",
			content: (item) => (
				<>
					<Icon
						type="show"
						data-tip
						data-for="show"
						onClick={() => {
							setLastPageData({ [modules.TRANSACTIONS]: transactionsPayload });
							navigate(`${URL.transactions}/${item?.order_id}`);
						}}
					/>
					<ReactTooltip id="show" place="top" effect="solid">
						Show
					</ReactTooltip>
				</>
			),
		},
	];

	return (
		<>
			<BreadCrumbs
				title="Payouts Management"
				data={[{ label: "Transactions" }]}
			/>
			<div className="dataTables_wrapper">
				<div className="content-area position-relative">
					<div className="grid">
						<div className="grid-content">
							<div className="user-listing-filterOptions mb-2 mt-3 d-block">
								<div className="row mb-2">
									<div className="col-sm-8 mb-2 position-static">
										<div className="left-buttons d-flex">
											<SearchBox
												columnKey={columnKey}
												searchValue={
													lastPageData?.[modules.TRANSACTIONS]?.search?.[
														"restaurant.name"
													]
												}
												search={(value) => {
													setPageNow(1);
													setTransactionsPayload({
														...transactionsPayload,
														search: {
															"restaurant.name":
																!value && value === "" ? undefined : value,
															"user.first_name":
																!value && value === "" ? undefined : value,
															"user.last_name":
																!value && value === "" ? undefined : value,
														},
														page: 1,
													});
												}}
											/>
										</div>
									</div>
									<div className="col-sm-4">
										<div className="right-buttons d-flex justify-content-end">
											<button
												className="btn btn-default minW-md-0 btn-bg-white"
												onClick={() =>
													downloadTransactionsOrders({
														...transactionsPayload,
														timeZone: CS.getTimezone(),
													})
												}
											>
												{isLoadingDownload ? "Downloading..." : "Download"}
											</button>
										</div>
									</div>
								</div>
							</div>

							<Table
								columnKey={columnKey}
								columns={columns}
								tableData={tableData}
								sortCol={(obj) => {
									setPageNow(1);
									setTransactionsPayload({
										...transactionsPayload,
										sort: {
											[obj.alias]:
												!obj.sort && obj.sort === "" ? undefined : obj.sort,
										},
										page: 1,
									});
								}}
								setCurrentPage={(page) => {
									setPageNow(page);
									setTransactionsPayload({
										...transactionsPayload,
										page,
									});
								}}
								setCurrentLimit={(items_per_page) => {
									setPageNow(1);
									setItemsPerPage(items_per_page);
									setTransactionsPayload({
										...transactionsPayload,
										items_per_page,
										page: 1,
									});
								}}
								loading={isLoading}
								filterValue={async (obj) => {
									if (obj.filter === null) {
										const resp = await CS.filterData(
											transactionsPayload.filter,
											obj
										);
										setPageNow(1);
										setTransactionsPayload({
											...transactionsPayload,
											filter: resp,
											page: 1,
										});
									} else {
										setPageNow(1);
										setTransactionsPayload({
											...transactionsPayload,
											filter: {
												...transactionsPayload.filter,
												[obj.alias]: obj.filter,
											},
											page: 1,
										});
									}
								}}
								filterDate={(dates) => {
									setPageNow(1);
									setTransactionsPayload({
										...transactionsPayload,
										filter_date: dates && {
											...transactionsPayload?.filter_date,
											[dates.alias]: dates.filter.map((value) => {
												return new Date(value).toISOString();
											}),
										},
										page: 1,
									});
								}}
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default Transactions;
